import moment from 'moment'

// 时间戳
const dateformat = (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') => {
  if (dataStr) {
    return moment(dataStr).format(pattern)
  } else {
    return '-'
  }
}

// 时间戳的时间差
const diffTime1 = (startDate, endDate) => {
  /* startDate= new Date(startDate)
  endDate = new Date(endDate) */
  var diff = Number(endDate) - Number(startDate) // 时间差的毫秒数
  // 计算出小时数
  var hours = Math.floor(diff / (3600))

  // 计算相差分钟数
  var leave2 = diff % (3600) // 计算小时数后剩余的毫秒数
  var minutes = Math.floor(leave2 / (60))

  var returnStr = ''
  if (minutes > 0) {
    returnStr = minutes + '分'
  }
  if (hours > 0) {
    returnStr = hours + '时' + returnStr
  }
  return returnStr || '-'
}

// 日期的时间差
const diffTime2 = (startDate, endDate) => {
  startDate = new Date(startDate)
  endDate = new Date(endDate)
  var diff = endDate.getTime() - startDate.getTime() // 时间差的毫秒数
  // 计算出小时数
  var hours = Math.floor(diff / (3600 * 1000))

  // 计算相差分钟数
  var leave2 = diff % (3600 * 1000) // 计算小时数后剩余的毫秒数
  var minutes = Math.floor(leave2 / (60 * 1000))

  var returnStr = ''
  if (minutes > 0) {
    returnStr = minutes + '分'
  }
  if (hours > 0) {
    returnStr = hours + '时' + returnStr
  }
  return returnStr || '-'
}

// 内容超过一定的字数显示省略号
const ellipsis = (str, num) => {
  var length = str.length
  if (length <= num) {
    return str
  } else {
    return str.slice(0, num - 3) + '...'
  }
}

// html显示问题
const escapeHtml = (str) => {
  var arrEntities = {
    'lt': '<',
    'gt': '>',
    'nbsp': ' ',
    'amp': '&',
    'quot': '"'
  }
  return str.replace(/&(lt|gt|nbsp|amp|quot);/ig, function(all, t) {
    return arrEntities[t]
  })
}

// 判断日期 今天/昨天/前天
const dateName = (date) => {
  let datename = ''

  // 今天
  let todayDate = new Date(); //今天
  let nowDataArr = [todayDate.getFullYear(),todayDate.getMonth()+1,todayDate.getDate()] // 今天的 年 月 日
  let todayName = nowDataArr[0]+'年'+(nowDataArr[1]*1 < 10 ? ('0' + nowDataArr[1]) : nowDataArr[1])+'月'+(nowDataArr[2]*1 < 10 ? ('0' + nowDataArr[2]) : nowDataArr[2])+'日'

  // 昨天
  let yesterdayDate = new Date(todayDate.setTime(todayDate.getTime()-24*60*60*1000))
  let yesterdayDateArr = [yesterdayDate.getFullYear(),yesterdayDate.getMonth()+1,yesterdayDate.getDate()] //昨天的 年 月 日
  let yesterdayName = yesterdayDateArr[0]+'年'+(yesterdayDateArr[1]*1 < 10 ? ('0' + yesterdayDateArr[1]) : yesterdayDateArr[1])+'月'+(yesterdayDateArr[2]*1 < 10 ? ('0' + yesterdayDateArr[2]) : yesterdayDateArr[2])+'日'
  
  // 前天
  let beforeYesterdayDate = new Date(todayDate.setTime(todayDate.getTime()-24*60*60*1000*2))
  let beforeYesterdayDateArr = [beforeYesterdayDate.getFullYear(),beforeYesterdayDate.getMonth()+1,beforeYesterdayDate.getDate()] //昨天的 年 月 日
  let beforeYesterdayName = beforeYesterdayDateArr[0]+'年'+(beforeYesterdayDateArr[1]*1 < 10 ? ('0' + beforeYesterdayDateArr[1]) : beforeYesterdayDateArr[1])+'月'+(beforeYesterdayDateArr[2]*1 < 10 ? ('0' + beforeYesterdayDateArr[2]) : beforeYesterdayDateArr[2])+'日'


  if (date === todayName) {
    datename = '今天'
  } else if (date === yesterdayName) {
    datename = '昨天'
  } else if (date === beforeYesterdayName) {
    datename = '前天'
  } else {
    datename = date
  }
  return datename
}

// 科目class
const courseClass = (str) => {
  var classname = ''
  if (str == '语文') {
    classname = 'yw'
  } else if (str == '数学') {
    classname = 'sx'
  } else if (str == '英语') {
    classname = 'yy'
  } else if (str == '物理') {
    classname = 'wl'
  } else if (str == '化学') {
    classname = 'hx'
  } else if (str == '政治') {
    classname = 'zz'
  } else if (str == '生物') {
    classname = 'sw'
  } else if (str == '历史') {
    classname = 'ls'
  } else if (str == '地理') {
    classname = 'dl'
  } else {
    classname = 'dl'
  }
  return classname
}



export {
  dateformat,
  diffTime1,
  diffTime2,
  ellipsis,
  escapeHtml,
  dateName,
  courseClass
}



// WEBPACK FOOTER //
// ./src/utils/filters.js